export const LocationStateConstants = {
  FilterStateName: 'locationFilter',
};

export const LocationFilterActions = {
  SetFilter: 'SET_LOCATION_FILTER',
};
